










import { defineComponent, computed } from '@vue/composition-api';
import UserConfigMobile from '@/renderer/components/user/components/userConfig/UserConfigMobile.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import { SettingTab } from '@/renderer/components/dialog/setting/SettingConst';
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    UserConfigMobile,
    SettingDialog,
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const settingInfo = { defaultPage: SettingTab.USER_CENTER.valueOf() };
    const methods = {
      signOut() {
        context.emit('signOut');
      },
    };
    return {
      innerShow,
      ...methods,
      settingInfo,
    };
  },
});
